export default __webpack_public_path__ + "static/0038-fc4e75fd0b1b88b3467a306906983e57.png";